import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@shared/service/user.service';
import { CommonService } from '@shared/service/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { utiles } from '@utl/environment';
import { environment } from '@env/environment';
import { LoginTokenModel } from '@core/model/loginToken.model';
import { MatDialog } from '@angular/material/dialog';
import { ModalVerificationEmailComponent } from '@shared/modal/modal-verification-email/modal-verification-email.component';
import { ModalSuccessComponent } from '@shared/modal/modal-success/modal-success.component';

@Component({
  selector: 'app-confirm-user',
  templateUrl: './confirm-user.component.html',
  styleUrls: ['./confirm-user.component.scss']
})
export class ConfirmUserComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private emailConfirmation = '';
  private tokenConfirmation = '';
  private loginToken: LoginTokenModel = new LoginTokenModel();
  constructor(
    private activatedRouter: ActivatedRoute,
    public userService: UserService,
    public commonService: CommonService,
    private router: Router,
    public dialog: MatDialog) {
    this.activatedRouter.queryParams.subscribe(params => {
      this.emailConfirmation = params.email;
      this.tokenConfirmation = params.token;
      localStorage.setItem('user-confirmation', this.emailConfirmation + ',' + this.tokenConfirmation);
      this.confirmUser();
    });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  confirmUser() {
    if (this.emailConfirmation !== '' && this.emailConfirmation !== null &&
      this.tokenConfirmation !== '' && this.tokenConfirmation !== null) {
      this.loginToken.UserEmail = this.emailConfirmation;
      this.loginToken.Token = this.tokenConfirmation;
      this.loginToken.TokenType = environment.TokenTypeRegisterConfim;
      this.userService.validateRegisterToken(this.loginToken)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          responseAuth => {
            utiles.clearCacheConfirmUser();
            if (responseAuth.item1 !== true) {
              this.opendialogResend('Enlace no disponible', 'Si lo desea, enviáremos uno nuevo al correo  ',
                this.emailConfirmation, '¡Dale click en reenviar!', 1);
            } else {
              responseAuth.item2.Origin = 'Ecommerce';
              this.userService.activateUser(responseAuth.item2)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe();
              this.opendialog('¡Felicidades!', 'Ya puede iniciar sesión.');
            }
          });
    }

  }

  resendEmail() {
    let userEmail = this.emailConfirmation;
    this.userService.resendConfirmationEmail(userEmail)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        () => {
          this.opendialogResend('Correo enviado', 'Hemos enviado un correo de verificación a ', this.emailConfirmation,
            '¡Haz click en el enlace que contiene para empezar!', 0);
        });
  }

  opendialogResend(title, message, link, indication, reSend): void {
    const dialogRef = this.dialog.open(ModalVerificationEmailComponent, {
      data: {
        labelTitile: title,
        icon: 'info',
        textDescription: message,
        textLink: link,
        textIndication: indication,
        status: 'success',
        showResend: reSend
      },
      panelClass: ['without-padding'],
      minWidth: '30vw', maxWidth: '95vw', maxHeight: '95vh', minHeight: '30vh', disableClose: true
    });
    dialogRef.componentInstance.onAccept
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        dialogRef.close();
        this.router.navigate(['login']);
      });
    dialogRef.componentInstance.onResend
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.resendEmail();
      });
  }
  
  opendialog(title, message): void {
    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      data: {
        labelTitile: title,
        icon: 'info',
        textDescription: message,
        status: 'success'
      },
      panelClass: ['without-padding'],
      minWidth: '30vw', maxWidth: '95vw', maxHeight: '95vh', minHeight: '30vh', disableClose: true
    });
    dialogRef.componentInstance.onAdd
      .subscribe(() => {
        dialogRef.close();
        this.router.navigate(['login']);
      });
  }
}
